import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SyncDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sync_disabled"}/>
}
